import axios from "axios";

import APIRoutes from "../../APIRoutes";

import { getAPIRoot } from "../../../utils/GeneralUtils";

/**
 * postCreateJikeiAccount
 *
 * Create a jikei user account.
 *
 * @param auth_token The user's auth token, used for fetching data that requires certain privileges.
 * @param name Name of user to be created.
 * @param email Mail address of user to be created.
 * @param is_manager Whether the user to be created is a manager or not.
 * @param school The school to which the creating user belongs.
 * @param course The course to which the creating user belongs.
 * @returns Authentication code email transmission result.
 */

export const postCreateJikeiAccount = async (
  auth_token: string,
  name: string,
  email: string,
  is_manager: boolean,
  school: string,
  course?: string
) => {
  await axios.post(
    getAPIRoot(APIRoutes.post.jikei.create_account, "jikei"),
    {
      sonic_full_name: name,
      sonic_email: email,
      sonic_school: school,
      sonic_course: course,
      sonic_is_manager: is_manager,
    },
    {
      headers: {
        "X-Sonic-Auth": auth_token,
      },
    }
  );

  return true;
};
